var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __spreadArray = (this && this.__spreadArray) || function (to, from) {
    for (var i = 0, il = from.length, j = to.length; i < il; i++, j++)
        to[j] = from[i];
    return to;
};
import { Entity } from '@decahedron/entity';
export var PipelineStageType;
(function (PipelineStageType) {
    PipelineStageType["ENTRY"] = "entry";
    PipelineStageType["HIRE"] = "hire";
    PipelineStageType["REJECTION"] = "rejection";
    PipelineStageType["CALL"] = "call";
    PipelineStageType["MEETING"] = "interview";
    PipelineStageType["REVIEW"] = "review";
})(PipelineStageType || (PipelineStageType = {}));
var PipelineStage = /** @class */ (function (_super) {
    __extends(PipelineStage, _super);
    function PipelineStage() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.id = null;
        _this.name = null;
        _this.type = null;
        _this.position = null;
        _this.totalCandidates = null;
        return _this;
    }
    PipelineStage.prototype.getIconForPipelineType = function (type) {
        if (type === void 0) { type = this.type; }
        switch (type) {
            case PipelineStageType.HIRE: return 'hired-column';
            case PipelineStageType.CALL: return 'call-column';
            case PipelineStageType.ENTRY: return 'new-column';
            case PipelineStageType.MEETING: return 'interview-column';
            case PipelineStageType.REVIEW: return 'review-column';
            case PipelineStageType.REJECTION: return 'rejected-column';
            default: return 'other-column';
        }
    };
    Object.defineProperty(PipelineStage.prototype, "assignablePipelineStageTypes", {
        get: function () {
            return __spreadArray(__spreadArray([], Object.values(PipelineStageType).filter(function (stage) { return stage !== PipelineStageType.HIRE && stage !== PipelineStageType.ENTRY && stage !== PipelineStageType.REJECTION; })), [null]);
        },
        enumerable: false,
        configurable: true
    });
    return PipelineStage;
}(Entity));
export { PipelineStage };
